export const COLORS = {
  success: "#136905",
  danger: "#AB0505",
};
